<template>
  <div class="time-spinner-picker">
    <div class="d-flex align-center justify-center primary white--text rounded-t py-1">
      <div
        class="d-flex flex-column align-center spinner-col"
        @touchmove.prevent="onTouchMove($event, 'hour')"
        @touchstart="onTouchStart"
        @wheel.prevent="onWheel($event, 'hour')"
      >
        <v-btn dark icon @click="stepHour(1)">
          <v-icon large>mdi-chevron-up</v-icon>
        </v-btn>
        <span :class="{ 'spinner-value--active': selecting === 1 }" class="spinner-value display-2" @click="setSelecting(1)">{{
          hourDisplay
        }}</span>
        <v-btn dark icon @click="stepHour(-1)">
          <v-icon large>mdi-chevron-down</v-icon>
        </v-btn>
      </div>
      <span class="display-2 mx-3">:</span>
      <div
        class="d-flex flex-column align-center spinner-col"
        @touchmove.prevent="onTouchMove($event, 'minute')"
        @touchstart="onTouchStart"
        @wheel.prevent="onWheel($event, 'minute')"
      >
        <v-btn dark icon @click="stepMinute(1)">
          <v-icon large>mdi-chevron-up</v-icon>
        </v-btn>
        <span :class="{ 'spinner-value--active': selecting === 2 }" class="spinner-value display-2" @click="setSelecting(2)">{{
          minuteDisplay
        }}</span>
        <v-btn dark icon @click="stepMinute(-1)">
          <v-icon large>mdi-chevron-down</v-icon>
        </v-btn>
      </div>
    </div>
    <v-time-picker
      ref="picker"
      :allowed-minutes="allowedMinutes"
      :value="value"
      class="rounded-t-0"
      color="primary"
      format="24hr"
      full-width
      light
      no-title
      @click:hour="selecting = 2"
      @input="v => $emit('input', v)"
    >
      <slot></slot>
    </v-time-picker>
  </div>
</template>

<script>
export default {
  name: 'TimeSpinnerPicker',
  props: {
    value: String,
    allowedMinutes: {
      type: Array,
      default: () => [0, 15, 30, 45],
    },
  },
  data() {
    return {
      // 1 = tunnin valinta, 2 = minuutin valinta (vastaa v-time-pickerin sisäistä selecting-tilaa)
      selecting: 1,
      wheelAccum: { hour: 0, minute: 0 },
      touchY: null,
    };
  },
  computed: {
    parsedTime() {
      const t = (this.value || '').split(':');
      if (t.length !== 2) return null;
      return { hour: parseInt(t[0]), minute: parseInt(t[1]) };
    },
    hourDisplay() {
      return this.parsedTime ? String(this.parsedTime.hour).padStart(2, '0') : '--';
    },
    minuteDisplay() {
      return this.parsedTime ? String(this.parsedTime.minute).padStart(2, '0') : '--';
    },
  },
  methods: {
    setSelecting(selecting) {
      this.selecting = selecting;
      this.$refs.picker.selecting = selecting;
    },
    emitTime(hour, minute) {
      this.$emit('input', `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`);
    },
    stepHour(direction) {
      const current = this.parsedTime || { hour: 0, minute: this.allowedMinutes[0] };
      this.emitTime((current.hour + direction + 24) % 24, current.minute);
    },
    stepUnit(unit, direction) {
      if (unit === 'hour') {
        this.stepHour(direction);
      } else {
        this.stepMinute(direction);
      }
    },
    onWheel(event, unit) {
      // Kerätään deltaa, jotta yksi rullan pykälä (~100) ja touchpadin pienet
      // liikkeet tuottavat kumpikin sopivan askellustahdin.
      this.wheelAccum[unit] += event.deltaY;
      if (Math.abs(this.wheelAccum[unit]) >= 40) {
        this.stepUnit(unit, this.wheelAccum[unit] < 0 ? 1 : -1);
        this.wheelAccum[unit] = 0;
      }
    },
    onTouchStart(event) {
      this.touchY = event.touches[0].clientY;
    },
    onTouchMove(event, unit) {
      if (this.touchY === null) return;
      const delta = this.touchY - event.touches[0].clientY;
      if (Math.abs(delta) >= 30) {
        this.stepUnit(unit, delta > 0 ? 1 : -1);
        this.touchY = event.touches[0].clientY;
      }
    },
    stepMinute(direction) {
      const current = this.parsedTime || { hour: 0, minute: this.allowedMinutes[0] };
      const sorted = [...this.allowedMinutes].sort((a, b) => a - b);
      let next;
      if (direction > 0) {
        next = sorted.find(m => m > current.minute);
        if (typeof next === 'undefined') next = sorted[0];
      } else {
        next = [...sorted].reverse().find(m => m < current.minute);
        if (typeof next === 'undefined') next = sorted[sorted.length - 1];
      }
      this.emitTime(current.hour, next);
    },
  },
};
</script>

<style scoped>
/* Isommat numeroympyrät ja fontti kellotauluun, jotta niihin osuu sormella */
.time-spinner-picker ::v-deep .v-time-picker-clock__item {
  font-size: 1.25rem;
  height: 44px;
  width: 44px;
}
.spinner-col {
  touch-action: none;
  user-select: none;
}
.spinner-value {
  cursor: pointer;
  opacity: 0.6;
}
.spinner-value--active {
  opacity: 1;
}
</style>
